import { useEffect, useState } from "react";
import axios from "axios";
import "./checkout.css";

export default function Checkout() {

  const [cart, setCart] = useState([]);

  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");

  const [paymentMethod, setPaymentMethod] = useState("COD");

  const user_id = localStorage.getItem("user_id");
useEffect(() => {

  const storeName =
    localStorage.getItem("storeLocation");

  axios
    .get(
      `https://apple2.shopat1stop.com/api/cart/${user_id}/${storeName}`
    )
    .then(res => setCart(res.data));

}, [user_id]);

  const total = cart.reduce((sum, item) => {
    return sum + item.price * item.quantity;
  }, 0);

  // PLACE ORDER
const placeOrder = async () => {

  if (!fullName || !phone || !address || !city || !zip) {
    alert("Please fill all fields");
    return;
  }

  // IF CARD PAYMENT → STRIPE FLOW
  if (paymentMethod === "CARD") {
    try {
      console.log("CHECKOUT CART:", cart);
     const res = await axios.post(
  "https://apple2.shopat1stop.com/api/create-checkout-session",
  {
    cart,
    total,
    user_id,
    customer_name: fullName,
    phone,
    address,
    city,
    zip
  }
);

      // redirect to Stripe checkout page
    window.open(res.data.url, "_self");

    } catch (err) {
      console.log(err);
      alert("Stripe payment failed ❌");
    }

    return;
  }

  // ELSE COD (your old flow)
  try {

    const orderData = {
      user_id,
      customer_name: fullName,
      phone,
      address,
      city,
      zip,
      payment_method: paymentMethod,
      total
    };

    const res = await axios.post(
      "https://apple2.shopat1stop.com/api/place-order",
      orderData
    );

    alert(res.data.message);
    window.location.href = "/";

  } catch (err) {
    console.log(err);
    alert("Order failed ❌");
  }
};

  return (
    <div className="checkout-page">

      {/* LEFT SIDE */}
      <div className="checkout-left">

        <h1 className="checkout-title">
          Secure Checkout
        </h1>

        {/* SHIPPING */}
        <div className="checkout-card">

          <div className="card-header">
            🚚 Shipping Address
          </div>

          <div className="card-body">

            <input
              placeholder="Full Name"
              value={fullName}
              onChange={(e) =>
                setFullName(e.target.value)
              }
            />

            <input
              placeholder="Phone Number"
              value={phone}
              onChange={(e) =>
                setPhone(e.target.value)
              }
            />

            <input
              placeholder="Street Address"
              value={address}
              onChange={(e) =>
                setAddress(e.target.value)
              }
            />

            <div className="row">

              <input
                placeholder="City"
                value={city}
                onChange={(e) =>
                  setCity(e.target.value)
                }
              />

              <input
                placeholder="ZIP Code"
                value={zip}
                onChange={(e) =>
                  setZip(e.target.value)
                }
              />

            </div>

          </div>

        </div>

        {/* PAYMENT */}
        <div className="checkout-card">

          <div className="card-header">
            💳 Payment Method
          </div>

          <div className="card-body payment-box">

            <label className="pay-option">

              <input
                type="radio"
                name="pay"
                checked={paymentMethod === "COD"}
                onChange={() =>
                  setPaymentMethod("COD")
                }
              />

              Cash on Delivery

            </label>

            <label className="pay-option">

              <input
                type="radio"
                name="pay"
                checked={paymentMethod === "CARD"}
                onChange={() =>
                  setPaymentMethod("CARD")
                }
              />

              Credit / Debit Card

            </label>

            <label className="pay-option">

              <input
                type="radio"
                name="pay"
                checked={paymentMethod === "PAYPAL"}
                onChange={() =>
                  setPaymentMethod("PAYPAL")
                }
              />

              PayPal

            </label>

          </div>

        </div>

      </div>

      {/* RIGHT SIDE */}
      <div className="checkout-right">

        <h2>Order Summary</h2>

        {cart.map(item => (

          <div
            className="summary-item"
            key={item.id}
          >

            <img
              src={`https://apple2.shopat1stop.com${item.image}`}
              alt={item.name}
            />

            <div className="summary-info">

              <h4>{item.name}</h4>

              <p>
                ${item.price} × {item.quantity}
              </p>

            </div>

          </div>

        ))}

        <div className="price-box">

          <div className="price-row">
            <span>Items Total</span>
            <span>${total.toFixed(2)}</span>
          </div>

          <div className="price-row">
            <span>Shipping</span>
            <span>FREE</span>
          </div>

          <div className="price-row total-row">
            <span>Total</span>
            <span>${total.toFixed(2)}</span>
          </div>

        </div>

        <button
          className="place-order-btn"
          onClick={placeOrder}
        >
          Place Your Order
        </button>

        <p className="secure-text">
          🔒 Secure SSL encrypted checkout
        </p>

      </div>

    </div>
  );
}